import { ismInitSwipers, ismInitSwiper, ismSwiperChange } from './js-carousel.js';

// Product Card Hover
export const initProductCardHover = () => {
  document.querySelectorAll('.product-card.btn-add-cart-on-hover').forEach((card) => {
    const productInfo = card.querySelector('.product-info');
    const addToCart = card.querySelector('.product-add-to-cart form');
    const productOptions = card.querySelector('.product-options fieldset');

    const handleHover = () => {
      if (window.innerWidth >= 1024) {
        let cardHeight = card.clientHeight;
        if (window.getComputedStyle(card).borderTopWidth !== '0px') {
          cardHeight += 2;
        }

        card.style.maxHeight = `${cardHeight}px`;
        card.classList.add('hovered');

        if (productInfo && addToCart) {
          let totalHeight = addToCart.offsetHeight;
          if (productOptions) {
            totalHeight += productOptions.offsetHeight;
          }
          productInfo.style.marginTop = `-${totalHeight}px`;
        }
      }
    };

    const handleLeave = () => {
      if (window.innerWidth >= 1024) {
        if (productInfo) {
          productInfo.style.marginTop = '';
        }

        card.classList.remove('hovered');

        setTimeout(() => {
          card.style.maxHeight = '';
        }, 200);
      }
    };

    card.addEventListener('mouseenter', handleHover);
    card.addEventListener('mouseleave', handleLeave);

    card.addEventListener('touchstart', handleHover);
    card.addEventListener('touchend', handleLeave);
  });
};

// Product Options
export const initProductOptions = () => {
  document
    .querySelectorAll('#mainProductSection .product-options .product-option input[type="radio"]')
    .forEach((input) => {
      input.addEventListener('click', (event) => {
        const productSectionId = 'mainProductSection';
        const optionValueElement = event.target;
        const productElement = document.getElementById(productSectionId);
        const sectionId = event.target.dataset.sectionId;
        const oldProductUrl = productElement.dataset.productUrl;
        const newProductUrl = optionValueElement.dataset.productUrl;
        const newVariantId = optionValueElement.dataset.variantId;
        const { productUrl } = event.target.dataset;
        const selectedOptionValues = Array.from(
          document.querySelectorAll('.product-options .product-option input[type="radio"]:checked')
        )
          .map((element) => element.dataset.optionValueId)
          .join(',');
        const params = `section_id=${sectionId}&option_values=${selectedOptionValues}`;

        fetch(`${productUrl}?${params}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');

            if (newProductUrl && oldProductUrl !== newProductUrl) {
              // Go to new page
              window.history.pushState({}, '', newProductUrl);
              window.location.reload();
              return;
            }

            // Update product section
            const elementsToUpdate = [
              { id: 'main-swiper', selector: '#main-swiper' },
              { id: 'thumbs-swiper', selector: '#thumbs-swiper' },
              { id: 'product-title', selector: '.product-title' },
              { id: 'product-price', selector: '.product-price' },
              { id: 'product-options', selector: '.product-options' },
              { id: 'product-stock', selector: '.product-stock' },
              { id: 'productVariantId', selector: '#productVariantId', isInput: true },
            ];

            elementsToUpdate.forEach(({ id, selector, isInput }) => {
              const newElement = html.querySelector(selector);
              const currentElement = document.querySelector(selector);

              if (newElement && currentElement) {
                if (isInput) {
                  currentElement.value = newElement.value;
                } else {
                  currentElement.innerHTML = newElement.innerHTML;
                }
              }
            });

            window.history.replaceState({}, '', newProductUrl + '?variant=' + newVariantId);
            // document.querySelector(`#${optionValueElement.id}`).focus();
            initProductOptions();
            ismInitSwipers();
            ismSwiperChange();
          });
      });
    });
};

// Product options on product cards
export const initProductCardOptions = () => {
  document.querySelectorAll('.product-card .product-options .product-option input[type="radio"]').forEach((input) => {
    input.addEventListener('click', (event) => {
      const closestProductCard = event.target.closest('.product-card');
      const variantId = event.target.dataset.variantId;
      const productUrl = closestProductCard.href;
      if (productUrl) {
        window.location.href = `${productUrl}?variant=${variantId}`;
      }
    });
  });
};

// Product Recommendations
export const initRecommendations = () => {
  document.querySelectorAll('.product-recommendations').forEach((section) => {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(section);

        const url = section.dataset.url;

        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.product-recommendations');

            if (recommendations && html.querySelector('.swiper')) {
              section.innerHTML = recommendations.innerHTML;
              ismInitSwiper(section.querySelector('.swiper'));

              initProductCardHover();
              initProductOptions();
              initProductCardOptions();
              initProductAddToCart();
            } else if (!Shopify.designMode) {
              section.classList.add('d-none');
            }
          })
          .catch((e) => {
            console.error(e);
          });
      },
      {
        rootMargin: '0px 0px 200px 0px',
      }
    );
    observer.observe(section);
  });
};

export const initProductAddToCart = () => {
  const forms = document.querySelectorAll('.shopify-product-form'); // Select all product forms
  forms.forEach((form) => {
    form.addEventListener('submit', async function (event) {
      event.preventDefault(); // Prevent the form from submitting
      console.log("Test");
      productAddToCart(form);
    });
  });
};

export const productAddToCart = async (form) => {
  const formData = new FormData(form);

  // Make the submit button disabled and show loading spinner
  const submitButton = form.querySelector('button[type="submit"]');
  let btnContent = '';
  if (submitButton) {
    submitButton.setAttribute('disabled', 'disabled');
    btnContent = submitButton.innerHTML;
    submitButton.innerHTML =
      '<div class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Loading...</span></div>';
  }

  // Use Shopify AJAX API to add the product to the cart
  await fetch('/cart/add.js', {
    method: 'POST',
    body: formData,
  })
    .then((response) => response.json())
    .then((product) => {
      // Update modal content with product details
      const modalElement = document.getElementById('crossSellingModal');
      const modal = bootstrap.Modal.getInstance(modalElement) || new bootstrap.Modal(modalElement);

      modalElement.querySelector('.product-title').textContent = product.title;
      modalElement.querySelector('.product-price').textContent = `€${(product.price / 100).toFixed(2)}`;
      const productImageBox = modalElement.querySelector('.product-image-box .placeholder-image');
      if (product.featured_image) {
        productImageBox.style.backgroundImage = `url(${product.featured_image.url})`;
        productImageBox.style.backgroundSize = 'cover';
        productImageBox.style.backgroundPosition = 'center';
      } else {
        productImageBox.style.backgroundImage = 'none';
      }

      // Fetch recommended products:
      const section = modalElement.querySelector('.cross-selling-recommendations');
      const swiperWrapper = modalElement.querySelector('.cross-selling-recommendations .swiper-wrapper');
      const intent = 'related'; // complementary or related

      fetch(
        window.Shopify.routes.root +
          'recommendations/products?product_id=' +
          product.product_id +
          '&limit=8&section_id=product-section-recommendations&intent=' +
          intent
      )
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-recommendations .swiper-wrapper');

          if (recommendations && html.querySelector('.swiper')) {
            swiperWrapper.innerHTML = recommendations.innerHTML;
            ismInitSwiper(section.querySelector('.swiper'));
            initProductCardHover();
            initProductOptions();
            initProductCardOptions();
            initProductAddToCart();
          } else if (!Shopify.designMode) {
            section.classList.add('d-none');
          }
        });

      if (modalElement.classList.contains('show')) {
        modal.hide();
        setTimeout(() => {
          modal.show();
        }, 500);
      } else {
        modal.show();
      }
    })
    .catch((error) => {
      console.error('Error adding product to cart:', error);
    });

  // Give the submit button it's original state back
  if (submitButton) {
    submitButton.removeAttribute('disabled');
    submitButton.innerHTML = btnContent;
  }

};
